/* eslint-disable @typescript-eslint/ban-types */
import React from 'react'
import fireEvent from 'react-app-events/lib/fireEvent'
import {productListInformation} from '@data/fragments/products/__generated__/productListInformation'
import productListInformationFragment from '@data/fragments/products/productListInformation'
import {EVENTS, sendPosthogData} from '@helpers/posthog'
import {withProductLink} from '@hooks/useProductLink'
import {NextRouter, withRouter} from 'next/router'
import {TFunction, withTranslation} from 'next-i18next'

import RowProduct from './Cards/RowProduct'
import Image from './Image'
import layout from './Layout'

import styles from './styles.module.css'

export interface ProductProps {
  router: NextRouter
  product: productListInformation
  menuId: string
  location?: any
  select?: Function
  hidePrice?: boolean
  productsLayout?: string
  productCardDesign?: string
  skipRedirection?: boolean
  productLink?: string
  t: TFunction
}

export class Product extends React.Component<ProductProps> {
  static fragment = productListInformationFragment

  state = {}

  onClick = () => {
    const {product, hidePrice, router} = this.props
    if (hidePrice) {
      fireEvent('hiddenPriceProductOpened', product)
      return
    }
    sendPosthogData(EVENTS.clicked.product)

    if (this.props.select) {
      this.props.select()
      return
    }
  }

  render() {
    const {product, productCardDesign, hidePrice, menuId, productLink} = this.props

    const description = product.description ? product.description.split('\n\n')[0] : ''

    const className = [this.props.productsLayout === 'compact' ? styles.compact : styles.container]
    if (product.isOutOfStock) {
      className.push(styles.isOutOfStock)
    }

    const image = <Image product={product} />

    const isRow = [
      'row',
      'row-inverse',
      'row-inverse-fast',
      'row-fast',
      'row-inverse-fast'
    ].includes(productCardDesign)

    if (isRow) {
      return (
        <RowProduct
          image={image}
          onClick={this.onClick}
          href={productLink}
          product={product}
          description={description}
          menuId={menuId}
          reverse={['row-inverse', 'row-inverse-fast'].includes(productCardDesign)}
          fastAddToCart={['row-fast', 'row-inverse-fast'].includes(productCardDesign)}
          hidePrice={hidePrice}
        />
      )
    }

    return layout({
      href: productLink,
      productsLayout: this.props.productsLayout,
      image,
      parentProps: this.props,
      className,
      onClick: this.onClick
    })
  }
}

export default withTranslation()(withRouter<ProductProps>(withProductLink(Product)))
